import CustomSelect from "../../../common/interactive/CustomSelect";
import CustomSelectMultiple from "../../../common/interactive/CustomSelectMultiple";
import Button from "../../../common/Button";
import { practicePatientStatusesOptions, practicesOptions } from "../../../../lib/systemData";

export default function PracticePatientStatusRepeaterOption({classes, filterItem, mainSelectAction, itemIndex, hasRemove}) {
    const practiceOptions = (practicesOptions() || []).filter(practice => Number(practice.practice_type) === 1)
    const statusOptions = practicePatientStatusesOptions(true) || []

    function onPracticeChange(value) {
        if (mainSelectAction) {
            mainSelectAction(value)
        }
    }

    function removeRepeaterItemHandler() {
        if (onPracticeChange) {
            onPracticeChange({
                data: {
                    value: null
                },
                identifier: {type: 'practice', index: itemIndex},
                isRemove: true
            })
        }
    }

    return <>
        <div className={classes.row}>
            <CustomSelect
                preSelectedValue={filterItem?.practice_id}
                optionsData={practiceOptions}
                label={'Practice'}
                identifier={{type: 'practice', index: itemIndex}}
                action={onPracticeChange}
                ignoreDeactivatedOptions={true}
                hasRemove={true}
            />
        </div>
        <div className={classes.row}>
            <CustomSelectMultiple
                preSelectedValue={filterItem?.practice_patient_status_id}
                identifier={{type: 'practice_patient_status', index: itemIndex}}
                optionsData={statusOptions}
                label={'Practice Patient Status'}
                action={mainSelectAction}
                isDisabled={!filterItem?.practice_id}
            />
        </div>
        {hasRemove && <div className={classes.remove_button}><Button click={removeRepeaterItemHandler}><i className="ti ti-minus"></i></Button></div>}
    </>
}
